/* eslint react/no-did-mount-set-state: 0, complexity: 0 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getSlpText} from '../../../utils/seo-text';
import {DynamicQuestions} from '../dynamic-seo-questions/dynamicQuestions';
function mapStateToProps(state) {
    return {
        slpText: state.content.slpText,
        destinationName: state.destination.details.simpleName,
        dynamicSeoText: state.destination.dynamicSeoText
    };
}

const textType = PropTypes.shape({
    paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.string,
            tags: PropTypes.arrayOf(PropTypes.string)
        })
    ),
    textType: PropTypes.string
});

export class SEOTextComponent extends Component {
    static propTypes = {
        slpText: PropTypes.objectOf(textType),
        destinationName: PropTypes.string,
        dynamicSeoText: PropTypes.shape({
            heading: PropTypes.string,
            paragraph: PropTypes.string
        })
    };

    render() {
        const textContent = getSlpText(this.props.slpText);
        const {heading, paragraph} = this.props.dynamicSeoText || {};

        return (<div className="container seo-text">
            <div className="content">
                <div className="row">
                    {!heading || !paragraph ? null : (
                        <div className="col-md-12">
                            <h2>{heading}</h2>
                            <p>{paragraph}</p>
                        </div>
                    )}
                    <DynamicQuestions />
                    {}
                    {textContent.length === 0 ? null :
                        /* eslint-disable react/no-danger */
                        (
                            <div className="col-md-12"
                                dangerouslySetInnerHTML={{
                                    __html: textContent
                                }}
                            />
                        )
                        /* eslint-enable react/no-danger */
                    }
                </div>
            </div>
        </div>);
    }
}

export const SEOText = connect(mapStateToProps)(SEOTextComponent);
export default SEOText;
